import { ResourceProps } from 'react-admin';

// Recurso INTANGIBLE (ver investments): sin rutas propias, registrado para las
// lecturas por referencia. Los intereses se ven y se editan en la ficha del
// inversor; el alta manual vive en su «Agregar» de Movimientos.
let resourceProps: ResourceProps = {
  name: 'interests',
};

export default resourceProps;
